import { Injectable } from "@angular/core";

import { Subject, Subscription } from 'rxjs';

class EventToken<_T> {
}

export class Events {
	public static readonly AccesListChanged = new EventToken<null>();
	public static readonly AssociationOperationsModalRequested = new EventToken<number>();
	public static readonly CreateAccesModalRequested = new EventToken<void>();
	public static readonly CreateAccesConduiteModalRequested = new EventToken<void>();
	public static readonly DuplicateAccesModalRequested = new EventToken<number>();
	public static readonly EditAccesModalRequested = new EventToken<number>();
	public static readonly EditUserPreferencesNotificationsRequested = new EventToken<null>();
	public static readonly NotificationDialogRequested = new EventToken<[number, string | null]>();
	public static readonly RefreshBatchIndicatorRequested = new EventToken<null>();
	public static readonly RefreshDataRequested = new EventToken<void>();
	public static readonly RefreshUserMenuRequested = new EventToken<void>();
	public static readonly CreateMemoModalRequested = new EventToken<number>();
}

@Injectable({ providedIn: 'root' })
export class EventBusService {
	private map = new Map<EventToken<any>, Subject<any>>();

	constructor(
	) {
		let register = <T>(token: EventToken<T>) => this.map.set(token, new Subject<T>());
		register(Events.AccesListChanged);
		register(Events.AssociationOperationsModalRequested);
		register(Events.CreateAccesModalRequested);
		register(Events.CreateAccesConduiteModalRequested);
		register(Events.DuplicateAccesModalRequested);
		register(Events.EditAccesModalRequested);
		register(Events.EditUserPreferencesNotificationsRequested);
		register(Events.NotificationDialogRequested);
		register(Events.RefreshBatchIndicatorRequested);
		register(Events.RefreshDataRequested);
		register(Events.RefreshUserMenuRequested);
		register(Events.CreateMemoModalRequested);
	}

	private getHandler<T>(identifier: EventToken<T>): Subject<T> {
		if (!identifier) {
			throw new Error("Event identifier is null!");
		}
		let handler = this.map.get(identifier) as Subject<T>;
		if (!handler) {
			throw new Error("Event handler is null!");
		}
		return handler;
	}

	// Cette fonction sert a donner acces a l'enum Events pour les controllers angularJS
	public events() {
		return Events;
	}

	public emit<T>(identifier: EventToken<T>, data: T) {
		let handler = this.getHandler(identifier);
		handler.next(data);
	}

	public observe<T>(identifier: EventToken<T>, consumer: (value: T) => void): Subscription {
		let handler = this.getHandler(identifier);
		// recupere et retourne le resultat du subscribe
		return handler.subscribe(consumer);
		
	}
	
}